import queryString from 'query-string';
import { RouteProps } from 'react-router';
import { withAnalyticOnView, enrichAnalytics, analytics } from 'react-shisell';
import { compose, lifecycle, withProps } from 'recompose';

import { AppProps, FooterConfig, HeaderConfig } from '../App';
import { PageConfig } from '../models';
import { RouteBasedProps } from './models';

export const withInitialState = (props: RouteBasedProps) =>
  lifecycle<RouteProps, RouteBasedProps>({
    componentDidMount() {
      this.setState(props);
    },
  });

export const withFooterConfig = (config: FooterConfig = { type: 'branded' }) =>
  lifecycle<AppProps, any>({
    componentDidMount() {
      this.props.setFooterType(config.type);
    },
  });

export const withHeaderConfig = (
  config: HeaderConfig = { isSticky: true, isNavigable: true, isLogoLinked: true, hideExpertChat: false }
) =>
  lifecycle<AppProps, any>({
    componentDidMount() {
      this.props.setIsHeaderSticky(config.isSticky);
      this.props.setIsHeaderNavigable(config.isNavigable);
      this.props.setIsHeaderLogoLinked(config.isLogoLinked);
      this.props.setHasSignupButton(config.hasSignupButton);
      this.props.setHideExpertChat(config.hideExpertChat);
      this.props.setBackTo(config.backTo);
    },
  });

export const composePage = ({ pageId }: PageConfig, ...functions: Array<Function>) =>
  compose(
    ...functions,
    withProps(() => ({
      pageId,
    })),
    withHeaderConfig(),
    withFooterConfig(),
    enrichAnalytics<any>((dispatcher, props) => {
      analytics.transformDispatcher((dispatcher) => dispatcher.withExtras({ PageId: props.pageId }));
      return dispatcher;
    }),
    withAnalyticOnView({
      analyticName: 'SH_WEB_EVENT',
      mapPropsToExtras: (props: any) => ({ ActionId: 'PageView', PageId: props.pageId }),
    })
  );

export const withQueryParamsAsProps = (whitelist: Array<string>) =>
  lifecycle<RouteProps, any>({
    componentDidMount() {
      const params = queryString.parse(this.props.location ? this.props.location.search : '');
      const whitelistedParams = whitelist.reduce((acc, key) => {
        const val = params[key];
        acc[key] = val === 'true' || val === 'false' ? JSON.parse(val) : val;
        return acc;
      }, {});
      this.setState(whitelistedParams);
    },
  });

export const withAgent = () =>
  lifecycle<RouteProps & AppProps, any>({
    componentDidMount() {
      this.props.setIsAgent(true);
    },
  });

export const withAgentFlow = () =>
  compose(
    withAgent(),
    withQueryParamsAsProps(['saleSessionId', 'agentId'])
  );



// WEBPACK FOOTER //
// ./packages/smart-home-support/routes/utils.ts